import { arrayOf, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isGetIosNotificationGroupsResult = arrayOf(
  objectOf({
    id: string,
    thread_id: string,
    name: string,
  })
);

export const isUpdateIosNotificationGroupsResult = arrayOf(
  objectOf({
    id: string,
    thread_id: string,
    name: string,
  })
);
